module.exports = "./img/96cb1d46e3f2a047da723ab293a6d58d.png";